
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","stroke":"#112A46","opacity":".5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.938 12.03l4.094-4.094","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M17.514 13.34h-1.67m-2.504 4.176v-1.67M2.486 6.66h1.67m2.505-4.175v1.67M12.59 10.474c.95.616 1.924.452 2.636-.26l2.496-2.496a2.088 2.088 0 000-2.952l-2.488-2.489a2.087 2.087 0 00-2.952 0L9.787 4.773c-.585.585-.923 1.697-.231 2.652M10.474 12.59c.616.95.452 1.925-.26 2.637L7.72 17.723a2.087 2.087 0 01-2.952 0L2.28 15.234a2.088 2.088 0 010-2.952l2.496-2.496c.584-.585 1.696-.922 2.651-.23","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    